"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

import type BlogAuthorAvatarsTemplate from "@/components/layout/BlogAuthorAvatars";
import { ReadableCopy, readableFallback } from "@/components/readable";
import { t } from "@/utils/t";

const BlogAuthorAvatars = dynamic(
  () => import("@/components/layout/BlogAuthorAvatars"),
  { ssr: false, loading: readableFallback() },
);

export default function ClientOnlyBlogAuthorAvatars(
  props: ComponentProps<typeof BlogAuthorAvatarsTemplate>,
) {
  const names = props.authors
    ?.map((author) =>
      `${t(author?.firstName, props.locale) ?? ""} ${t(author?.lastName, props.locale) ?? ""}`.trim(),
    )
    .filter(Boolean);

  return (
    <ReadableCopy copy={names?.length ? <p>{names.join(", ")}</p> : null}>
      <BlogAuthorAvatars {...props} />
    </ReadableCopy>
  );
}
